module.exports = __webpack_public_path__ + "media/application/images/features/bundles-1100-b15dd776a5b3ea3aabdf2294f24e3316.png";